import styled from 'styled-components';

export const Root = styled.div`
  margin: 50px 78px 50px 50px;
`

export const Title = styled.span`
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
`

export const TagsContainer = styled.div`
  display: flex;
`

export const TagColumn = styled.div`
  width: calc(50% - 28px);
  min-height: 100px;
`

export const VerticalDivider = styled.div`
  width: 56px;
  min-height: 100px;
`

export const LoadingContainer = styled.div`
  margin: 75px 0px 0px 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #b0aeae;
`

export const EmptyContainer = styled.div`
  margin: 75px 0px 0px 0px;
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #b0aeae;
`

export const ChipsContainer = styled.div`
  margin: 10px 0px 0px 0px;
  display: flex;
  flex-wrap: wrap;
`